import React, { PropsWithChildren } from 'react'
import ReactDOM from 'react-dom'

export const Portal = React.forwardRef(({ children }: PropsWithChildren<any>, ref) => {
  const mountNode = document.body
  return ReactDOM.createPortal(children, mountNode)
})

export default Portal
